import React from 'react';

export default class ForgeStronghold extends React.PureComponent {
    static propTypes = {};
    render() {
        return (
            <div className="forge-stronghold container-fluid">
                <div className="background" />
                <div className="sword" />
                <div className="content">
                    <h1>Forge A Stronghold</h1>
                    <p>Build, fortify, and upgrade the ancient Sky Tower to strengthen
                        your citizens and reinforce your defenses.
                    </p>
                </div>
            </div>
        );
    }
}

